export default "__VITE_ASSET__qlwwfGpT__"